

































import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import Welcome from '@/components/Global/Welcome.vue';
import PolicySelector from '@/components/Global/PolicySelector.vue';

import MmicPolicyList from '@/components/Policy/MmicPolicyList.vue';

import PolicyDocuments, { PolicyDocumentMetadata, PolicyPacket } from '@/services/PolicyDocuments';
import Policy from '@/services/Policy';

import store from '@/store/index';
import SelectField from '@/components/Form/SelectField.vue';
import * as Sentry from '@sentry/browser';
import { Getter, State } from 'vuex-class';
import moment from 'moment';
@Component({
	name: 'PagePolicy',
	components: {
		Loading,
		MmicPolicyList,
		Alert,
		Welcome,
		PolicySelector,
	},
})
export default class MmicPolicy extends Vue {
	@Getter('thirtyDayPolicies', { namespace: 'Policy' }) private policies: any;
	private error: boolean = false;
	private loading: boolean = false;
	private searchText: string = '';
	private selectedPolicy: any = '';
	private modifiedPolicies: any[] = [];
	private packetizedPolicyDocMetadata: any;
	private effectiveFrom: any;
	private effectiveTo: any;
	private noDocuments: boolean = false;
	private inRenewelState: boolean = false;

	private headingDescription: string = `
          <i
               class="fas fa-file-alt fa-5x d-none d-md-block float-left"
               style="color: #1F98BE;margin-bottom: 30px;margin-right:30px"
          ></i>
		<p>
			Access your policy documents below. Your Certificates of Insurance (COI), as well as
			related coverages and endorsements, can be found under "Download all policy forms &
			endorsements.
		</p>
		<p>
			If you have more than one policy, select the one you wish to view by clicking on the
			policy number or policyholder name to view and access your reports.
		</p>
		`;

	private searchByNameOrNumber() {
		const policies = this.policies;
		const regex = new RegExp(this.searchText.toLowerCase(), 'gi');
		this.modifiedPolicies = policies.filter(
			p => p.policyNumber.toLowerCase().match(regex) || p.riskName.toLowerCase().match(regex),
		);
	}

	private convertUTCDateToLocalDate(date) {
		const convertedLocalTime = new Date(date);
		const hourOffset = convertedLocalTime.getTimezoneOffset() / 60;
		convertedLocalTime.setHours(convertedLocalTime.getHours() + hourOffset);
		return convertedLocalTime;
	}

	private async changePolicyNum(e) {
		this.noDocuments = false;
		this.inRenewelState = false;
		this.error = false;
		this.selectedPolicy = e;

		if (this.selectedPolicy) {
			try {
				this.loading = true;

				const getPolicyData = this.policies.find(
					p => p.policy_number === this.selectedPolicy,
				);

				if (
					getPolicyData &&
					getPolicyData.policy_status === 'ACTIVE' &&
					!getPolicyData.policy_term_status
				) {
					this.inRenewelState = false;
				} else if (getPolicyData && getPolicyData.policy_term_status === 'PENDING') {
					this.inRenewelState = true;
				}

				// if (!this.inRenewelState) {
				const policyDocMetadata = await PolicyDocuments.getPolicyDocumentMetadatas(
					this.selectedPolicy,
				);
				console.log(policyDocMetadata);
				if (policyDocMetadata.length === 0) {
					this.noDocuments = true;
					return;
				}
				this.policies.map(policy => {
					if (policy.policy_number === this.selectedPolicy) {
						this.effectiveFrom = policy.effective_from_date;
						this.effectiveTo = policy.effective_to_date;
					}
				});

				this.packetizedPolicyDocMetadata = PolicyDocuments.packetizePolicyDocumentMetadatasForMmic(
					policyDocMetadata,
					this.selectedPolicy,
					this.convertUTCDateToLocalDate(this.effectiveFrom),
				);
				// }
			} catch (error) {
				Sentry.captureException(error);
				this.error = true;
			} finally {
				this.loading = false;
			}
		}
	}
	private getMainRisk(policy) {
		if (policy && policy.risks) {
			const mainRiskIndex = Object.keys(policy.risks).find(
				risk => 'main_risk' in policy.risks[risk] && policy.risks[risk].main_risk === 'Y',
			);

			if (mainRiskIndex === undefined) {
				throw new Error('Unknown');
			}

			const mainRisk = policy.risks[mainRiskIndex];

			return mainRisk;
		} else {
			return null;
		}
	}
}
